<script setup>
  import RadioControl from '@/components/RadioControl.vue';

  const model = defineModel();

  const options = {
    short: 'Short Range',
    long: 'Long Range'
  };
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'model-range-' + value" class="jwx-table-view__row-label">{{ label }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="model"
                name="model-range"
                :id="'model-range-' + value"
                :value="value"
                :srLabel="'Select ' + label"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
